import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Globe } from 'lucide-react';
import {
  DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent, DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { LANGUAGES } from '@/i18n';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger data-testid="nav-language">
        <Globe className="w-4 h-4 mr-2" /> {t('nav.language')}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="rounded-2xl glass-panel">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
          >
            <span className="flex-1">{l.label}</span>
            {current === l.code && <Check className="w-4 h-4 ml-2 text-brand" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
